<template>
  <div class="row row-sm">
    <div
      class="col-lg-12"
    >
      <VueSlickCarousel
        v-bind="slickSettings"
        :style="calculateHeight()"
        class="home-slider"
        v-if="jumbotrons && jumbotrons.length"
      >
        <div
          class="home-slide"
          :style="{
            backgroundImage: `url(${baseUrl}${getBackgroundImage(item)})`,
            ...calculateHeight()
          }"
          v-for="item in jumbotrons"
          :key="item.id"
        >
          <a :href="item.contentUrl">
            <div class="slide-content" :class="`content-${item.alignment}`">
              <div class="text-wrapper">
                <h2
                  :class="`text-${item.alignment}`"
                  :style="{ color: item.titleColour, fontSize: item.titleFontSize + 'px' }"
                  v-if="item.title"
                >{{ item.title }}</h2>
                <div class="skew-box-group"
                v-if="item.secondaryDescription || item.mainDescription">
                  <span
                    class="skew-box"
                    :style="{
                      color: item.mainDescriptionColour,
                      fontSize: item.mainDescriptionFontSize + 'px'
                    }"
                    v-if="item.mainDescription"
                  >
                    {{ item.mainDescription }}
                  </span>
                  <span
                    class="skew-box"
                    :style="{
                      color: item.secondaryDescriptionColour,
                      fontSize: item.secondaryDescriptionFontSize + 'px'
                    }"
                    v-if="item.secondaryDescription"
                  >
                    {{ item.secondaryDescription }}
                  </span>
                </div>
              </div>
              <a
                v-if="item.contentUrl"
                :href="item.contentUrl"
                class="btn btn-light text-primary
                font-weight-bold bottom-absolute
                width-fit-content px-2"
                target="_blank"
              >
                {{ item.linkText || item.contentUrl }}
              </a>
            </div>
          </a>
          <p v-if="item.fusnote">* {{ item.fusnote }}</p>
        </div>
      </VueSlickCarousel>

      <div
        :style="calculateHeight()"
        v-else
      >
        <div
          class="home-slide"
          :style="{
            backgroundImage: 'url(assets/images/banners/jumbotron.jpeg)',
            ...calculateHeight()
          }"
        >
          <div class="slide-content">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import './slick.css';

import config from '@/config';

export default {
  name: 'Jumbotron',
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      isMobile: window.innerWidth < 575,
      slickSettings: {
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 500,
        autoplaySpeed: 5000,
        cssEase: 'ease',
      },
    };
  },
  computed: {
    jumbotrons() {
      return this.$store.getters.getJumbotrons;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  methods: {
    calculateHeight() {
      const menu = document.getElementById('submenu-height');
      return {
        height: menu?.offsetHeight ? `${menu?.offsetHeight}px` : '450px',
      };
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 575;
    },
    getBackgroundImage(item) {
      if (this.isMobile && item.mobileImage) {
        return item.mobileImage;
      }
      return item.image;
    },
  },
  mounted() {
    this.$store.dispatch('getAllJumbotrons');
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
};
</script>
<style lang="scss" scoped>
@import './jumbotron.scss';
.home-slider {
  width: calc(100% - 275px);
}
@media screen and (max-width: 1479px) {
  .home-slider {
    width: calc(100% - 230px) !important;
  }
}

@media screen and (max-width: 991px) {
  .home-slider {
    width: 100% !important;
  }
}
.skew-box {
  transform: skew(0deg, 0deg);
}
.width-fit-content {
  width: fit-content;
}
</style>
